export default __webpack_public_path__ + "static/recommended-c3bcd49727e8935547fd6b67681689b7.png";